import React from 'react';

import PropTypes from 'prop-types';
import { FaArrowRight } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

import workerHeroImage from '../../Assets/img/worker.webp';
import WithBackground from '../Common/WithBackground';

import './style.css';

const WorkerHero = ({ bg, overlay = 'dark' }) => {
  const { t } = useTranslation();

  const heroContent = (
    <section className={`worker-hero ${bg ? '' : 'bgr'}`}>
      <div className='worker-hero__container'>
        <div className='worker-hero__grid'>
          <div className='worker-hero__content'>
            <h1
              className='worker-hero__title'
              data-aos='fade-up'
              data-aos-delay='100'
            >
              {t('workerHero.title')}
              <br />{' '}
              <span className='worker-hero__title--accent'>
                {t('workerHero.titleAccent')}
              </span>
            </h1>

            <p
              className='worker-hero__subtitle'
              data-aos='fade-up'
              data-aos-delay='200'
            >
              {t('workerHero.subtitle')}
            </p>

            <div
              className='worker-hero__actions'
              data-aos='fade-up'
              data-aos-delay='300'
            >
              <a href='#contact' className='btn__cta worker-hero__cta'>
                <FaArrowRight className='btn__cta-icon' />
                {t('workerHero.contactRecruitment')}
              </a>

              <a
                href='/oferty-pracy'
                className='btn__cta worker-hero__cta worker-hero__cta--secondary'
              >
                <FaArrowRight className='btn__cta-icon' />
                {t('workerHero.viewJobs')}
              </a>
            </div>
          </div>

          <div
            className='worker-hero__media'
            data-aos='fade-left'
            data-aos-delay='400'
          >
            <img
              src={workerHeroImage}
              alt={t('workerHero.imageAlt')}
              className='worker-hero__image'
            />
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {heroContent}
    </WithBackground>
  ) : (
    heroContent
  );
};

WorkerHero.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

WorkerHero.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default WorkerHero;
